import React, { Fragment, useState } from 'react';
import { Button, UploadFile } from '@comall-backend-builder/components-basis';
import { Modal as AntModal, Form, Input, message } from 'antd';
import { ComponentsManager } from '@comall-backend-builder/core';
import { actions, services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';

const api = services.api;

const LiveBannerAdd = (props: any) => {
    console.log(props);
    const { form, entity } = props;
    const [visible, setVisible] = useState(false);
    function onShow() {
        setVisible(true);
    }

    function onSave(e) {
        e.preventDefault();
        form.validateFields((err, values) => {
            console.log(values, 'values');
            if (!err) {
                const { name, imgUrl, url } = values;
                const params = {
                    name,
                    imgUrl: imgUrl[0].path,
                    url,
                    sort: 1,
                    status: 'DISPLAY',
                };
                entity.add(params);
                message.success('添加成功');
                setVisible(false);
                form.resetFields();
                entity.search({
                    ...entity.params,
                });
            }
        });
    }
    return (
        <Fragment>
            <Button type="primary" onClick={onShow} style={{ marginBottom: 20 }}>
                添加
            </Button>
            <AntModal
                visible={visible}
                title={'添加'}
                onCancel={() => {
                    setVisible(false);
                    form.resetFields();
                }}
                onOk={onSave}
                mask
                width={1000}
            >
                <Form layout="vertical">
                    <Form.Item label="名称">
                        {form.getFieldDecorator('name', {
                            rules: [{ required: true, message: '名称为必填项' }],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="图片">
                        {form.getFieldDecorator('imgUrl', {
                            rules: [{ required: true, message: '图片为必填项' }],
                        })(
                            <UploadFile
                                maxCount={1}
                                fileName={'fileName'}
                                uploadType={'single'}
                                multiple={true}
                                sortable={true}
                                name={'bannerUpload'}
                                uploadUrl={`${ENV.API_ROOT}/images`}
                                mode={'picture-card'}
                                maxSize={10240}
                                uploadLimitSizeErrorMessage={
                                    '图片{{ file.name }}超出限制，最大上传 {{ maxSize }} kb 图片'
                                }
                            ></UploadFile>
                        )}
                    </Form.Item>
                    <Form.Item label="链接">{form.getFieldDecorator('url')(<Input />)}</Form.Item>
                </Form>
            </AntModal>
        </Fragment>
    );
};

export const LiveBannerAddPage = Form.create()(LiveBannerAdd);
